import API from './API.js'
import axios from 'axios'
import i18n from '@/libs/i18n/index.js'

export default class EduContent extends API {
  constructor(eduCourseId) {
    super(`edu_courses/${eduCourseId}/edu_contents`)
  }
  async getAllContents(eduProgramId, params) {
    const response = await axios.get(`/getAllContents/${eduProgramId}`, { params })
    return response.data
  }
  GetType(type) {
    return this.Types().find((a) => a.type == type);
  }
  Types(all = true) {
    let type = [
      {
        icon: "HeadphonesIcon",
        title: i18n.t('content.voice_lectures'),
        type: "voice_lectures",
        color: "primary",
      },
      {
        icon: "FilmIcon",
        title: i18n.t('content.interactive_video_lectures'),
        type: "interactive_video_lectures",
        color: "secondary",
      },
      {
        icon: "CastIcon",
        title: i18n.t('content.direct_lectures'),
        type: "direct_lectures",
        color: "success",
      },
      {
        icon: "FileTextIcon",
        title: i18n.t('content.scrom_lectures'),
        type: "scrom_lectures",
        color: "warning",
      },
      {
        icon: "ArchiveIcon",
        title: i18n.t('content.powerpoint_lectures'),
        type: "powerpoint_lectures",
        color: "danger",
      },
      {
        icon: "FilePlusIcon",
        title: i18n.t('content.pdf'),
        type: "pdf",
        color: "info",
      },
      {
        icon: "SpeakerIcon",
        title: i18n.t('content.uploaded_voice_lectures'),
        type: "uploaded_voice_lectures",
        color: "primary",
      },
      {
        icon: "VideoIcon",
        title: i18n.t('content.video_lectures'),
        type: "video_lectures",
        color: "secondary",
      },

    ];
    if (all) {
      type.push({
        icon: "PenToolIcon",
        title: i18n.t('content.exam'),
        type: "exam",
        color: "success",
      },
        {
          icon: "HeadphonesIcon",
          title: i18n.t('content.assessments'),
          type: "assessments",
          color: "warning",
        })
    }
     return type;
  }
  async Order(data, headers = {}) {
    try {
      // debugger
      const response = await axios.post(`/${this.route}/order`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }


  }
  //getAllContents
  // async Insert(data, eduCourseId, headers = {}) {
  //   try {
  //     const response = await axios.post(`/edu_courses/${eduCourseId}/${this.route}`, data, headers)
  //     return response.data
  //   } catch (error) {
  //     if (error.response) {
  //       // Request made and server responded
  //       return error.response.data;

  //     }
  //   }
  // }
}
